/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Boundary_ReloadInputs */

const en_us2_errors_boundary_reload = /** @type {(inputs: Errors_Boundary_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload`)
};

const pt_br2_errors_boundary_reload = /** @type {(inputs: Errors_Boundary_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarregar`)
};

const es_419_errors_boundary_reload = /** @type {(inputs: Errors_Boundary_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargar`)
};

const pt_pt2_errors_boundary_reload = /** @type {(inputs: Errors_Boundary_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarregar`)
};

const fr_fr2_errors_boundary_reload = /** @type {(inputs: Errors_Boundary_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recharger`)
};

const de_de2_errors_boundary_reload = /** @type {(inputs: Errors_Boundary_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu laden`)
};

const it_it2_errors_boundary_reload = /** @type {(inputs: Errors_Boundary_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricarica`)
};

/**
* | output |
* | --- |
* | "Reload" |
*
* @param {Errors_Boundary_ReloadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const errors_boundary_reload = /** @type {((inputs?: Errors_Boundary_ReloadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Boundary_ReloadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_errors_boundary_reload(inputs)
	if (locale === "es-419") return es_419_errors_boundary_reload(inputs)
	if (locale === "pt-PT") return pt_pt2_errors_boundary_reload(inputs)
	if (locale === "fr-FR") return fr_fr2_errors_boundary_reload(inputs)
	if (locale === "de-DE") return de_de2_errors_boundary_reload(inputs)
	if (locale === "it-IT") return it_it2_errors_boundary_reload(inputs)
	return en_us2_errors_boundary_reload(inputs)
});
export { errors_boundary_reload as "errors-boundary.reload" }